export const INDEX_SOCIAL = 'social';
export const MODAL_FOX = 'modal fox';
export const OPEN_TYPE = 'open';
export const LOCATION_TYPE = 'location';
export const LOCATIONTV_TYPE = 'location-tv';
export const PORVER = 'porver';
export const SUSCRIPTION_CHANNEL = 'SuscriptionChannel';
export const SOCIALIZATION = 'socializacion';
export const CAROUSEL = 'carrusel';
export const INFINITE_LIST = 'Listado Infinito';
export const ERROR_RECORDING = 'ErroRecording';
export const OBJECT = 'object';
export const EXECUTOR = 'executor';
export const SCROLL = 'scroll';
export const URL_IMAGE_ERROR = '/webclient/sk_core/images/place_hl.png';
export const SECTIONCLASS =
  'section-12 section-recomendador-1 section-sugest section-doble';
export const URL_IMAGE_ERROR_SMALL =
  '/webclient/sk_core/images/place_small.png';
export const UNSUPPORTED_PLAY_RECORDING_TITLE_BOLD =
  'unsupported_play_recording_title_bold';
export const UNSUPPORTED_PLAY_RECORDING_TITLE =
  'unsupported_play_recording_title';
export const UNSUPPORTED_PLAY_RECORDING_MSG = 'unsupported_play_recording_msg';
export const HOME_USER_RECOME2ONE_FIRST_TITLE =
  'home_user_recome2one_first_title';
export const HOME_USER_RECOME2ONE_SECOND_TITLE =
  'home_user_recome2one_second_title';
export const HOME_USER_RECOME2ONE_ONE_TITLE = 'home_user_recome2one_one_title';
export const PREDICTSEARCH_SUGGEST_LABEL = 'predictSearch_suggest_label';
export const TEXT_BUTTON_BACK = 'text_button_back';
export const EPISODE = 'episode';
export const SEASON = 'season';
export const COMMON_PUBLISHYEAR = 'common_publishyear';
export const SYNOPSIS = 'finPlayer_Ser_synopsis';
export const MORE_INFO = 'common_mas_info';
export const GROUP_BUTTON_ADDFAN = 'grupo_button_addFan';
export const TV = 'tv';
export const GUIA = 'guia';
export const GUIDE_CHANNEL = 'guidechannels';
